import { useAppTheme } from '@capsicum/common';
import { type NCOnboardingPageProps, useNCOnboarding } from '@capsicum/features/nc-onboarding/shared';
import { useCallback, useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Swiper, type SwiperClass, type SwiperProps, SwiperSlide } from 'swiper/react';

import { FirstSlide } from './slides/FirstSlide';
import { FourthSlide } from './slides/FourthSlide';
import { SecondSlide } from './slides/SecondSlide';
import { ThirdSlide } from './slides/ThirdSlide';

type NCOnboardingProps = Pick<NCOnboardingPageProps, 'onDone'>;

export const NcOnboarding = ({ onDone }: NCOnboardingProps) => {
	const { allThemes } = useAppTheme();
	const [swiper, setSwiper] = useState<null | SwiperClass>();
	const { isLoading, onActiveSlideChange } = useNCOnboarding();

	const goToNextSlide = useCallback(() => {
		if (swiper) swiper.slideNext();
	}, [swiper]);

	const onSlideChange = useCallback<Exclude<SwiperProps['onSlideChange'], undefined>>(
		swiper => onActiveSlideChange(swiper.realIndex),
		[onActiveSlideChange]
	);

	return (
		<ThemeProvider theme={allThemes.dark}>
			<S.Wrapper>
				<S.StyledSwiper
					allowTouchMove
					lazyPreloadPrevNext={3}
					slidesPerView={1}
					onSlideChange={onSlideChange}
					onSwiper={setSwiper}
				>
					<SwiperSlide>
						<FirstSlide isLoading={isLoading} onNextSlide={goToNextSlide} />
					</SwiperSlide>

					<SwiperSlide>
						<SecondSlide onNextSlide={goToNextSlide} />
					</SwiperSlide>

					<SwiperSlide>
						<ThirdSlide onNextSlide={goToNextSlide} />
					</SwiperSlide>

					<SwiperSlide>
						<FourthSlide onNextSlide={onDone} />
					</SwiperSlide>
				</S.StyledSwiper>
			</S.Wrapper>
		</ThemeProvider>
	);
};
namespace S {
	export const Wrapper = styled.div`
		height: 100dvh;
	`;

	export const StyledSwiper = styled(Swiper)`
		height: 100%;
		background-color: ${({ theme }) => theme.colors.backgrounds.onboarding};
	`;
}
